import React, { useEffect } from 'react';
import Table from '../components/Table/Table';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useViewVisited from '../features/app/hooks/useViewVisted';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import FileOpenIcon from '@material-ui/icons/OpenInNew';
import {
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions
} from '@material-ui/core';
import {
  getHasRecalledError,
  getPpsisReviewSummary,
  getReviewMarketCount,
  isFetchingSummary
} from 'features/PpsiContainer/selectors';
import {
  fetchPpsisReviewSummary,
  hasRecalledPPSIError,
  navigateToReviewPage,
  navigateToReviewPageDone
} from 'features/PpsiContainer/actions';
import { toJS } from '../utils/immutableUtils';
import { globalMarketReviewRoute } from 'routes';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import useMarketLabel from 'features/app/hooks/useMarketLabel';

const GlobalReviewSummary = () => {
  const ppisReviewSummarys = useSelector(getPpsisReviewSummary);
  const ppisReviewSummary = toJS(ppisReviewSummarys, []);
  const [isFetchingMarket, marketNames, fetchNameError] = useMarketLabel();
  const isFetching = useSelector(isFetchingSummary);
  const dispatch = useDispatch();
  const history = useHistory();
  const hasRecalledError = useSelector(getHasRecalledError);
  const reviewMarketCount = useSelector(getReviewMarketCount);

  const { isViewVisited } = useViewVisited(
    View.ReviewWaitingSummary.name,
    isFetching
  );
  const isFetched = isViewVisited ? true : !isFetching || !isFetchingMarket;

  useEffect(() => {
    dispatch(fetchPpsisReviewSummary());
  }, []);

  useEffect(() => {
    if (ppisReviewSummary.length && reviewMarketCount) {
      let object = ppisReviewSummary.filter(
        a => a.market === reviewMarketCount.market
      )[0];
      if (object && object.NoofObjects > object.count) {
      } else {
        if (object) {
          setTimeout(() => {
            // history.push(globalMarketReviewRoute(object.market));
            window.location.href = globalMarketReviewRoute(object.market);
          }, 100);
        }
        dispatch(navigateToReviewPageDone());
      }
    }
  }, [reviewMarketCount]);

  if (isFetching || isFetchingMarket) {
    return <ProgressFullscreen />;
  }

  function createMarketDisplayLabel(data) {
    const result = {};
    data.forEach(i => {
      result[i.countryCode] = i.displayLabel;
    });
    return result;
  }

  const marketLabelToDisplay = createMarketDisplayLabel(marketNames);

  View.ReviewWaitingSummary.visit();

  if (fetchNameError) {
    throw fetchNameError;
  }

  const GlobalReviewColumns = {
    MarketName: {
      name: 'marketName',
      label: 'Market Name',
      calculateCellValue: rowData => {
        const { market } = rowData;
        const name = marketLabelToDisplay[market];
        return name;
      },
      //   filterable: true,
      sortable: true,
      width: 200,
      grow: 0,
      shrink: 0
    },
    MarketCode: {
      name: 'market',
      dataField: 'market',
      sortable: false,
      label: 'Code',
      width: 120,
      grow: 0,
      shrink: 0
    },
    Numbers: {
      name: 'NoofObjects',
      dataField: 'NoofObjects',
      //   filterable: true,
      sortable: false,
      label: 'Total Review Pending',
      width: 180,
      grow: 0,
      shrink: 0
    },
    PreviewActions: {
      name: 'action',
      label: 'Actions',
      CellValue: ({ rowData }) => {
        return (
          <Tooltip title={`Go to ${rowData.market} market`}>
            <IconButton
              onClick={() => {
                dispatch(
                  navigateToReviewPage(
                    rowData.market,
                    rowData.NoofObjects,
                    history
                  )
                );
                //  return checkOutToMarket(rowData.market)
              }}
              color="secondary"
              size="medium"
            >
              <FileOpenIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
      // link: rowData => globalMarketReviewRoute(rowData.market),
      grow: 0,
      shrink: 0,
      width: 45,
      sortable: false,
      searchable: false
    },
    EmptySpace: {
      name: 'itemCode',
      dataField: 'itemCode',
      sortable: false,
      label: '  '
    }
  };

  return (
    <>
      <PaperContainer showProgress={!isFetched}>
        <Table
          title="globalReviewSummary.globalReviewTitle"
          // title="updatesList.updatesTableHeader"
          data={ppisReviewSummary}
          columns={[
            GlobalReviewColumns.MarketName,
            GlobalReviewColumns.MarketCode,
            GlobalReviewColumns.Numbers,
            GlobalReviewColumns.PreviewActions,
            GlobalReviewColumns.EmptySpace
          ]}
          getObjectId={object => object.id}
          defaultSorting={[{ columnName: 'market', direction: 'asc' }]}
          selectable
        />
      </PaperContainer>

      <Dialog open={hasRecalledError}>
        <DialogContent>
          <DialogContentText component="div">
            Instruction recalled by Market Admin. <br />
            Press 'Back to the list' to refresh the page.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            key="stay"
            onClick={() => {
              dispatch(hasRecalledPPSIError(false));
              dispatch(fetchPpsisReviewSummary());
              // globalMarketReviewRoute(localMarket)
              // if (reviewPpsis.length === 1) {
              //   globalWaitingReviewRoute();
              // } else {
              //   dispatch(fetchReviewPpsis(filter, marketCode));
              //   dispatch(hasRecalledPPSIError(false));
              // }
            }}
            color="primary"
            style={{ marginRight: '10px' }}
          >
            BACK TO THE LIST
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GlobalReviewSummary;
